export default {
  errorDefault: 'Помилка сталася',
  unknown: 'Невідомий',
};
